import React from "react";

export const LazyClientAgentConnectedSurveillanceAppPage = React.lazy(
    () =>
        import(
            /* webpackChunkName: "ClientAgentConnectedSurveillanceApp" */ "./ClientAgentConnectedSurveillanceApp"
        )
);
